import _objectSpread from "/var/lib/jenkins/workspace/wyt-admin/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = {
  class: "toolbox"
};
const _hoisted_2 = {
  class: "wrapper"
};

const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账时间", -1);

const _hoisted_4 = {
  class: "wrapper"
};

const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账参与方", -1);

const _hoisted_6 = {
  class: "wrapper"
};

const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账参与方类型", -1);

const _hoisted_8 = {
  class: "wrapper"
};

const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "结算团队", -1);

const _hoisted_10 = {
  class: "wrapper"
};

const _hoisted_11 = /*#__PURE__*/_createTextVNode("查询");

const _hoisted_12 = /*#__PURE__*/_createTextVNode("重置");

const _hoisted_13 = {
  class: "table-toolbox"
};
const _hoisted_14 = {
  class: "left"
};
const _hoisted_15 = {
  class: "wrapper"
};

const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "分账金额合计：", -1);

const _hoisted_17 = {
  class: "value"
};
const _hoisted_18 = {
  class: "wrapper"
};

const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "已结算金额合计：", -1);

const _hoisted_20 = {
  class: "value"
};
const _hoisted_21 = {
  class: "wrapper"
};

const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "label"
}, "待结算金额合计：", -1);

const _hoisted_23 = {
  class: "value"
};
const _hoisted_24 = ["onClick"];
const _hoisted_25 = {
  key: 1
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  key: 1
};
const _hoisted_28 = ["onClick"];
const _hoisted_29 = {
  key: 1
};
const _hoisted_30 = ["onClick"];
const _hoisted_31 = {
  key: 1
};
const _hoisted_32 = ["onClick"];
const _hoisted_33 = ["onClick"];
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { getVexTableProps } from '@/config';
import Axios from '@/request/createAxiosInstalce';
import Tool from '@/utils/tool';
import SettleModal from './components/settle-modal.vue';
export default {
  name: 'settle-list',

  setup(__props) {
    const router = useRouter();
    onMounted(() => getSupplierList());
    const now = new Date();
    const lastMonthStartDate = Tool.formatTime(new Date(now.getFullYear(), now.getMonth() - 1, 1));
    const lastMonthEndDate = Tool.formatTime(new Date(now.getFullYear(), now.getMonth(), 0));
    const dateRange = ref([lastMonthStartDate, lastMonthEndDate]);
    const search = ref({
      supplierId: '',
      participateRole: '',
      participateName: ''
    });
    const statistic = ref({});
    const table = ref();
    const tableOptions = getVexTableProps({
      columns: [{
        title: '角色',
        field: 'participateRoleName'
      }, {
        title: '分账参与方',
        field: 'participateName'
      }, {
        title: '分账金额（已入账金额）',
        field: 'splitAmount'
      }, {
        title: '涉及订单',
        field: 'orderNum',
        slots: {
          default: 'orderNum'
        }
      }, {
        title: '已结算金额',
        field: 'hasSettlementAmount'
      }, {
        title: '已结算订单',
        field: 'hasSettlementOrderNum',
        slots: {
          default: 'hasSettlementOrderNum'
        }
      }, {
        title: '待结算金额',
        field: 'unSettlementAmount'
      }, {
        title: '待结算订单',
        field: 'unSettlementOrderNum',
        slots: {
          default: 'unSettlementOrderNum'
        }
      }, {
        title: '待提现金额',
        field: 'withdrawAmount'
      }, {
        title: '待提现订单',
        field: 'withdrawOrderNum',
        slots: {
          default: 'withdrawOrderNum'
        }
      }, {
        title: '操作',
        field: 'operation',
        slots: {
          default: 'operation'
        }
      }],
      proxyConfig: {
        ajax: {
          query: ({
            page
          }) => {
            let range = dateRange.value || ['', ''];

            let query = _objectSpread({
              startTime: range[0],
              endTime: range[1]
            }, search.value);

            return new Promise(resolve => {
              let params = _objectSpread({
                page: page.currentPage,
                pageSize: page.pageSize
              }, query);

              Axios.get('/admin/split/settlement/getSplitSettlementList.json', {
                params
              }).then(res => {
                if (!res.data.success) return;
                statistic.value = res.data.data.settlementStatistics || {};
                resolve({
                  total: res.data.data.total,
                  result: res.data.data.list
                });
              });
            });
          }
        }
      }
    });

    function reset() {
      search.value = {
        supplierId: '',
        participateRole: '',
        participateName: ''
      };
      dateRange.value = [lastMonthStartDate, lastMonthEndDate];
      table.value.commitProxy('reload');
    }

    const supplierList = ref([]);

    function getSupplierList() {
      // let params = { isFilterManufacture: 1 }
      Axios.get('/admin/split/rule/getLevelOneSupplierList.json').then(res => {
        supplierList.value = res.data.data;
      });
    }

    const settleModal = ref({
      show: false,
      data: {}
    });

    function settleHandle(row) {
      let range = dateRange.value || ['', ''];
      settleModal.value = {
        show: true,
        data: _objectSpread({
          startTime: range[0],
          endTime: range[1]
        }, row)
      };
    }

    function toFlowHandle(row, type) {
      let query = {
        startTime: row.orderMinTime,
        endTime: row.orderMaxTime,
        participateId: row.participateId,
        participateRole: row.participateRole
      };

      switch (type) {
        case 'orderNum':
          // query.participateName = row.participateName
          break;

        case 'hasSettlementOrderNum':
          query.settlementStatus = '1,2';
          break;

        case 'unSettlementOrderNum':
          query.settlementStatus = '0,2';
          break;

        case 'withdrawOrderNum':
          query.withdrawStatus = '0';

        default:
          break;
      }

      router.push({
        name: 'sepaccountFlow',
        query
      });
    }

    return (_ctx, _cache) => {
      const _component_el_date_picker = _resolveComponent("el-date-picker");

      const _component_el_input = _resolveComponent("el-input");

      const _component_el_option = _resolveComponent("el-option");

      const _component_el_select = _resolveComponent("el-select");

      const _component_el_button = _resolveComponent("el-button");

      const _component_vxe_grid = _resolveComponent("vxe-grid");

      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createVNode(_component_el_date_picker, {
        modelValue: dateRange.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => dateRange.value = $event),
        type: "daterange",
        "value-format": "YYYY-MM-DD",
        style: {
          "flex": "0 0 300px"
        },
        "start-placeholder": "开始时间",
        "end-placeholder": "结束时间",
        "unlink-panels": ""
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_el_input, {
        modelValue: search.value.participateName,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => search.value.participateName = $event),
        placeholder: "请输入"
      }, null, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_el_select, {
        modelValue: search.value.participateRole,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => search.value.participateRole = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), _createVNode(_component_el_option, {
          label: "平台",
          value: "1"
        }), _createVNode(_component_el_option, {
          label: "商业公司",
          value: "2"
        }), _createVNode(_component_el_option, {
          label: "销售团队",
          value: "3"
        }), _createVNode(_component_el_option, {
          label: "团队成员（下单人）",
          value: "4"
        }), _createVNode(_component_el_option, {
          label: "团队成员（分账受益人）",
          value: "5"
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_el_select, {
        modelValue: search.value.supplierId,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => search.value.supplierId = $event)
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          label: "全部",
          value: ""
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(supplierList.value, item => {
          return _openBlock(), _createBlock(_component_el_option, {
            label: item.supplierName,
            value: item.supplierId
          }, null, 8, ["label", "value"]);
        }), 256))]),
        _: 1
      }, 8, ["modelValue"])]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[4] || (_cache[4] = $event => table.value.commitProxy('reload'))
      }, {
        default: _withCtx(() => [_hoisted_11]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: reset
      }, {
        default: _withCtx(() => [_hoisted_12]),
        _: 1
      })])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", _hoisted_17, "￥" + _toDisplayString(statistic.value.sumSettlementAmount), 1)]), _createElementVNode("div", _hoisted_18, [_hoisted_19, _createElementVNode("span", _hoisted_20, "￥" + _toDisplayString(statistic.value.hasSettlementAmount), 1)]), _createElementVNode("div", _hoisted_21, [_hoisted_22, _createElementVNode("span", _hoisted_23, "￥" + _toDisplayString(statistic.value.unSettlementAmount), 1)])])]), _createVNode(_component_vxe_grid, _mergeProps({
        ref_key: "table",
        ref: table
      }, _unref(tableOptions)), {
        orderNum: _withCtx(({
          row
        }) => [row.orderNum > 0 ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toFlowHandle(row, 'orderNum')
        }, _toDisplayString(row.orderNum), 9, _hoisted_24)) : (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(row.orderNum), 1))]),
        hasSettlementOrderNum: _withCtx(({
          row
        }) => [row.hasSettlementOrderNum > 0 ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toFlowHandle(row, 'hasSettlementOrderNum')
        }, _toDisplayString(row.hasSettlementOrderNum), 9, _hoisted_26)) : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(row.hasSettlementOrderNum), 1))]),
        unSettlementOrderNum: _withCtx(({
          row
        }) => [row.unSettlementOrderNum > 0 ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toFlowHandle(row, 'unSettlementOrderNum')
        }, _toDisplayString(row.unSettlementOrderNum), 9, _hoisted_28)) : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(row.unSettlementOrderNum), 1))]),
        withdrawOrderNum: _withCtx(({
          row
        }) => [row.withdrawOrderNum > 0 ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: "javascript:;",
          onClick: $event => toFlowHandle(row, 'withdrawOrderNum')
        }, _toDisplayString(row.withdrawOrderNum), 9, _hoisted_30)) : (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(row.withdrawOrderNum), 1))]),
        operation: _withCtx(({
          row
        }) => [_createElementVNode("a", {
          href: "javascript:;",
          onClick: $event => toFlowHandle(row)
        }, "分账流水", 8, _hoisted_32), _createElementVNode("a", {
          href: "javascript:;",
          style: {
            "margin-left": "10px"
          },
          onClick: $event => settleHandle(row)
        }, "结算", 8, _hoisted_33)]),
        _: 1
      }, 16), _createVNode(SettleModal, {
        modelValue: settleModal.value.show,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => settleModal.value.show = $event),
        data: settleModal.value.data,
        supplierId: search.value.supplierId,
        onSuccess: _cache[6] || (_cache[6] = $event => table.value.commitProxy('reload'))
      }, null, 8, ["modelValue", "data", "supplierId"])]);
    };
  }

};